(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-builder"]) return;
  try {
    
document.querySelectorAll('[data-sh-about-v12]').forEach(function(root) {
  var tabs = root.querySelectorAll('[data-sh-about-tab]');
  var slides = root.querySelectorAll('[data-sh-about-slide]');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var index = tab.getAttribute('data-sh-about-tab');

      tabs.forEach(function(item) {
        var active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      slides.forEach(function(slide) {
        var active = slide.getAttribute('data-sh-about-slide') === index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
    });
  });

  var revealItems = root.querySelectorAll('.sh-about-v12__reveal');

  if (!('IntersectionObserver' in window)) {
    revealItems.forEach(function(item) {
      item.classList.add('is-visible');
    });
  } else {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -5% 0px'
    });

    revealItems.forEach(function(item) {
      observer.observe(item);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
